// NAVIGATION FORM TYPES
export const GET_NAVIGATION = 'GET_NAVIGATION';
export const UPDATE_NAVIGATION = 'UPDATE_NAVIGATION';